import { render, staticRenderFns } from "./m-product-additional-info.vue?vue&type=template&id=d34d6cb0&scoped=true&"
import script from "./m-product-additional-info.vue?vue&type=script&lang=js&"
export * from "./m-product-additional-info.vue?vue&type=script&lang=js&"
import style0 from "./m-product-additional-info.vue?vue&type=style&index=0&id=d34d6cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34d6cb0",
  null
  
)

export default component.exports